import { useEffect, useState } from "react";

export default function PdfMessage({ pdfUrl, fileName, fileSize }) {
    const [blobUrl, setBlobUrl] = useState(null);

    useEffect(() => {
        const accessToken = localStorage.getItem("authUser");
        const token = accessToken?.replace(/^"|"$/g, "");

        const fetchPDF = async () => {
            try {
                const response = await fetch(pdfUrl, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (!response.ok) throw new Error("Failed to load PDF");

                const blob = await response.blob();
                const url = URL.createObjectURL(blob);
                setBlobUrl(url);
            } catch (error) {
                console.error("PDF fetch error:", error);
            }
        };

        fetchPDF();
    }, [pdfUrl]);

    if (!blobUrl) {
        return <div className="tw-p-4 tw-text-sm tw-text-gray-500">Loading PDF...</div>;
    }

    return (
        <div className="tw-flex tw-items-start tw-justify-start tw-p-2">
            <div className="tw-bg-green-100 tw-rounded-lg tw-p-3 tw-w-72">
                {/* PDF Preview */}
                <div className="tw-bg-gray-200 tw-rounded-md tw-mb-2 tw-overflow-hidden">
                    <iframe src={blobUrl} className="tw-w-full tw-h-32 tw-border-none" />
                </div>

                {/* File Details */}
                <div className="tw-text-sm tw-font-semibold tw-text-gray-700 tw-truncate">{fileName}</div>
                <div className="tw-text-xs tw-text-gray-500">{fileSize} KB, PDF Document</div>

                {/* Action Buttons */}
                <div className="tw-flex tw-justify-between tw-mt-2">
                    <a
                        href={blobUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="tw-bg-primary hover:tw-bg-primary_hover tw-text-white tw-text-sm tw-py-1 tw-px-3 tw-rounded-md tw-shadow-sm tw-font-medium"
                    >
                        Open
                    </a>
                    <a
                        href={blobUrl}
                        download={fileName}
                        className="tw-bg-primary hover:tw-bg-primary_hover tw-text-white tw-text-sm tw-py-1 tw-px-3 tw-rounded-md tw-shadow-sm tw-font-medium"
                    >
                        Save as..
                    </a>
                </div>
            </div>
        </div>
    );
}
